const SController = ({ title, data, register, elment }) => {
  //custom-select
  return (
    <div className="custom-select">
      <select
        name={elment}
        id={elment}
        {...register(elment)}
        className="input-blue text-dark w-100 p-3 border fw-light"
      >
        {data.map((option, index) => (
          <option value={option.value} key={title + "-" + index}>
            {option.title}
          </option>
        ))}
      </select>
    </div>
  );
};
export default SController;
